export default __webpack_public_path__ + "static/media/twitter-1456037401562779657.bec27d27.jpg";